import { changepassportdetails } from './ActionTypes';

const changePassportDetails = (passportDetails) => {
    return (dispatch)=>{
        dispatch({type: changepassportdetails, passportDetails:passportDetails})
    }
}

export default changePassportDetails;